"use client";

import { create } from "zustand";
import { DashboardFiltersState } from "../types";

export const useDashboardFilters = create<DashboardFiltersState>((set) => ({
  filters: {
    startDate: "",
    endDate: "",
    datePreset: "this_month",
    group_id: null,
    cities: [],
    spaces: [],
    users: [],
    status: [],
    type: [],
  },
  filterCount: 0,
  setFilters: (patch) => set((s) => ({ filters: { ...s.filters, ...patch } })),
  setDateRange: (start, end) =>
    set((s) => ({ filters: { ...s.filters, startDate: start, endDate: end } })),
  setFilterCount: (count) => set({ filterCount: count }),
}));
